import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const IngredientsRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  background: '$tertiary-200',
})

export const IngredientsContainer = styled('div', {
  position: 'relative',
  width: '100%',
  maxWidth: '500px',
  margin: '$5 auto $6',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 $2',
  '@bp2': {
    maxWidth: '1072px',
    margin: '$8 auto',
  },
})

export const Title = styled('h2', {
  fontSize: '$h3',
  marginBottom: '$4',
  '@bp2': {
    fontSize: '$h1',
    marginBottom: '$5',
  }
})

export const IngredientRow = styled('div', {
  width: '100%',
  padding: '$3 $1',
  borderTop: '1px solid $accent-black',
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
  alignItems: 'flex-start',
  '&:first-child': {
    borderTop: '2px solid $accent-black',
  },
  '&:last-child': {
    borderBottom: '2px solid $accent-black',
  },
})
